module.exports = __webpack_public_path__ + "img/object.802626a6.png";